import styled from 'styled-components';
import colors from 'constants/colors';

const ProgramImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  background-color: ${colors.main.dividers};
`;

export default ProgramImage;
